import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

interface Props {
  label: string;
  value: ReactNode;
  sub?: ReactNode;
  icon?: ReactNode;
  color?: string;
  onClick?: () => void;
}

export function StatCard({ label, value, sub, icon, color = '#3478d4', onClick }: Props) {
  const Tag = onClick ? 'button' : 'div';
  return (
    <Tag onClick={onClick} className={cn('card p-5 text-start', onClick && 'transition hover:-translate-y-0.5 hover:shadow-lg')}>
      <div className="flex items-start justify-between gap-2">
        <span className="text-xs text-muted">{label}</span>
        {icon && (
          <span className="grid size-9 place-items-center rounded-[11px]" style={{ background: `${color}18`, color }}>
            {icon}
          </span>
        )}
      </div>
      <strong className="ltr-nums mt-4 mb-1.5 block text-end text-[22px] font-bold">{value}</strong>
      {sub && <span className="text-[11px] text-muted">{sub}</span>}
    </Tag>
  );
}
